import pipefitterApi from '../../../services/pipefitterApi';
import type { PipeStatusItem } from '../types';
import {
  buildPipeStatusListQueryParams,
  isGetPipeStatusListSuccess,
  parsePipeStatusListResponse,
  type PipeStatusListFilterPayload,
} from './pipeStatusList';

/** GET `/v1/reports/getPipeDataList` — lightweight pipe names for report pickers. */
export function getPipeDataListUrl(query: URLSearchParams): string {
  return `/reports/getPipeDataList?${query.toString()}`;
}

export type PipeDataListPickerItem = { id: string; pipeID: string };

/** Map getPipeDataList rows to `{ id, pipeID }` for report pipe pickers. */
export function mapPipeDataListRowsToPickerItems(
  rows: Array<PipeStatusItem | Record<string, unknown>>
): PipeDataListPickerItem[] {
  return rows.map((pipe) => {
    const row = pipe as PipeStatusItem & { pipeId?: string | number };
    return {
      id: String(row.id ?? row.pipeStatusId ?? row.pipeID),
      pipeID: String(row.pipeID ?? row.pipeId ?? row.id),
    };
  });
}

/**
 * Unpaginated pipe list for report modals (same query params as getPipeStatusList).
 */
export async function fetchPipeDataList(
  filterPayload: PipeStatusListFilterPayload
): Promise<PipeStatusItem[]> {
  const params = buildPipeStatusListQueryParams(filterPayload);
  const { data } = await pipefitterApi.get(getPipeDataListUrl(params));
  if (!isGetPipeStatusListSuccess(data)) {
    return [];
  }
  return parsePipeStatusListResponse({ data }).rows;
}
